module.exports = __webpack_public_path__ + "design.jpg?7fc98d4f9258331cee63a1a1297d466c";


//////////////////
// WEBPACK FOOTER
// ./src/images/design.jpg
// module id = 83
// module chunks = 0